const SpecialCalculations = (id, value, fieldChanges) => {

    if (value !== undefined && value !== null) {
        switch (id.toLowerCase()) {
            case "dateofbirth":
                var currentDate = new Date(value);
                var milliseconds = Date.now() - currentDate.getTime();
                var ageAsDate = new Date(milliseconds);
                var year = ageAsDate.getUTCFullYear();
                var ageInYears = Math.abs(year - 1970);
                var ageInMonths = ageAsDate.getUTCMonth();

                var rowToChange = fieldChanges.findIndex(r => r.key === "Age");
                if (rowToChange !== -1) {
                    fieldChanges[rowToChange] = {key: 'Age', value: ageInYears};
                } else {
                    fieldChanges.push({key: 'Age', value: ageInYears});
                }
                rowToChange = fieldChanges.findIndex(r => r.key === "AgeMonths");
                if (rowToChange !== -1) {
                    fieldChanges[rowToChange] = {key: 'AgeMonths', value: ageInMonths};
                } else {
                    fieldChanges.push({key: 'AgeMonths', value: ageInMonths});
                }
    
                break;
            default:
        }
    }

    return fieldChanges;
}

export default SpecialCalculations;